import React from "react";
import { Link } from "react-router-dom";
import AuthBar from "./AuthBar";
import { isClerkEnabled } from "../utils/clerkConfig";
import LanguageSwitcher from "./LanguageSwitcher";
import { useI18n } from "../i18n/i18n";

export default function Breadcrumbs({ current }) {
  const { t, localizePath } = useI18n();
  const normalizedCurrent = String(current || "").trim();
  const separatorIndex = normalizedCurrent.indexOf(":");
  const hasDetail = separatorIndex !== -1;
  const mobileSection = hasDetail
    ? normalizedCurrent.slice(0, separatorIndex).trim()
    : normalizedCurrent;
  const mobileDetail = hasDetail
    ? normalizedCurrent.slice(separatorIndex + 1).trim()
    : "";
  const logoAlt = `${t("common.appName")} Logo`;

  return (
    <nav className="breadcrumbs" aria-label={t("breadcrumbs.ariaLabel")}>
      <div className="breadcrumbsLeft breadcrumbsLeft--desktop">
        <Link to={localizePath("/")} className="breadcrumbsHomeLink" aria-label={t("breadcrumbs.dashboard")}>
          <picture>
            <source
              type="image/webp"
              srcSet="/images/fit-log-logo-80.webp 1x, /images/fit-log-logo-160.webp 2x"
            />
            <img
              src="/images/fit-log-logo.png"
              srcSet="/images/fit-log-logo-80.png 1x, /images/fit-log-logo-160.png 2x"
              alt={logoAlt}
              className="logo"
              width="80"
              height="80"
            />
          </picture>
        </Link>
        <span className="current" aria-current="page">{current}</span>
      </div>
      <div className="breadcrumbsLeft breadcrumbsLeft--mobile">
        <div className="breadcrumbsMobileLine breadcrumbsMobileLine--primary">
          <Link to={localizePath("/")} className="breadcrumbsHomeLink" aria-label={t("breadcrumbs.dashboard")}>
            <picture>
              <source
                type="image/webp"
                srcSet="/images/fit-log-logo-80.webp 1x, /images/fit-log-logo-160.webp 2x"
              />
              <img
                src="/images/fit-log-logo.png"
                srcSet="/images/fit-log-logo-80.png 1x, /images/fit-log-logo-160.png 2x"
                alt={logoAlt}
                className="logo"
                width="80"
                height="80"
              />
            </picture>
          </Link>
          <span className="current current--section" aria-current="page">{mobileSection}</span>
        </div>
        {mobileDetail && (
          <div className="breadcrumbsMobileLine breadcrumbsMobileLine--secondary">{mobileDetail}</div>
        )}
      </div>
      <div className="breadcrumbsRight">
        <LanguageSwitcher />
        <AuthBar enabled={isClerkEnabled} />
      </div>
    </nav>
  );
}
